// Class: openfl.display.ITileContainer

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var ITileContainer = function() {}

// Meta

ITileContainer.__name__ = "openfl.display.ITileContainer";
ITileContainer.__isInterface__ = true;
ITileContainer.prototype = {
	
};
ITileContainer.prototype.__class__ = ITileContainer.prototype.constructor = $hxClasses["openfl.display.ITileContainer"] = ITileContainer;

// Init



// Statics




// Export

exports.default = ITileContainer;